import { render, staticRenderFns } from "./FcCompanyBio.vue?vue&type=template&id=29fe1a3a&scoped=true&"
import script from "./FcCompanyBio.vue?vue&type=script&lang=js&"
export * from "./FcCompanyBio.vue?vue&type=script&lang=js&"
import style0 from "./FcCompanyBio.vue?vue&type=style&index=0&id=29fe1a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fe1a3a",
  null
  
)

export default component.exports